import { IReleaseNote } from "../types"

export const RELEASE_1_5_0: IReleaseNote = {
    status: "PAST",
    title: "v1.5.0",
    date: "31st March 2025",
    releaseType: "Minor",
    notesBodyAllUsers: [
        {
            heading: "Introduction",
            content:
                "We are excited to announce ENA Connect Direct 1.5.0 was released on 31st March 2025. This is a minor release and it contained new features to make the site better, faster and more accurate. These notes outline the key changes.",
        },
    ],
    notesBodyInstaller: [
        {
            heading: "For installers using the web portal",
            subtitle: "Feature Summary",
            bullets: [
                "Drafts: You will be able to save drafts for the connection applications, allowing you to save an application mid way and return later to submit without losing any changes. ",
                "Amendments: The amendment functionality has been extended for applications in a qualifying state. Installers can modify everything in the application except the MPAN, address, auto-populated installer details, and high-level technology type (e.g., SOLAR, BATTERY, EVCP)",
                "More information on both features is available in the FAQ section, providing detailed insights into each of the new functionalities",
            ],
        },
        {
            heading: "The following changes have been added:",
            subtitle: "Drafts:",
            bullets: [
                "You will be able to save drafts for the connection applications, allowing you to save an application mid way and return later to submit without losing any changes",
                "Draft applications will be created automatically throughout the application process with an autosave feature enabling for regular incremental saves (every 15 seconds)",
                "Once a draft has been made they will be available within the 'My Drafts' page displaying basic information to help identify drafts",
                "Drafts can be filtered and searched for using key fields to further support finding specific draft applications",
                "Drafts will be autodeleted after 6 months in no changes have been made and will be flagged after 5 months to signal that this draft is close to deletion",
                "Users have the ability to delete drafts within the My Drafts page",
            ],
        },
        {
            subtitle: "Amendments:",
        },
        {
            bullets: [
                "The amendment functionality has been extended for applications in a qualifying state.",
                "Installers can modify everything in the application except the MPAN, address, auto-populated installer details, and high-level technology type (e.g., SOLAR, BATTERY, EVCP)",
                "New qualifying states for Amendments now include: auto-approved, re-auto-approved, approved, approved with limit, failed too large, failed invalid cut-out, failed, image recognition failed, further information required.",
                "All existing amendment functionality has remained the same",
                "Once a decision is made (or auto-approved) email communications are sent to installer / customer - this is the only deviation from the existing amendment process. During amendments in release 1.4.0, no further communications were issued to customers / installations. This will be reversed, and communications will be sent during an amendment. These communications will be identical to the email communications issued during the 'initial application process.",
            ],
        },
        {
            heading: "For installers using our APIs",
            subtitle: "Feature Summary",
            bullets: [
                "Amendments: The amendment functionality has been extended for applications in a qualifying state. Installers can modify everything in the application except the MPAN, address, auto-populated installer details, and high-level technology type (e.g., SOLAR, BATTERY, EVCP)",
            ],
        },
        {
            heading: "The following changes have been added:",
            subtitle: "Amendments:",
            bullets: [
                "The amendment functionality has been extended for applications in a qualifying state.",
                "Installers can modify everything in the application except the MPAN, address, auto-populated installer details, and high-level technology type (e.g., SOLAR, BATTERY, EVCP)",
                "New qualifying states for Amendments now include: auto-approved, re-auto-approved, approved, approved with limit, failed too large, failed invalid cut-out, failed, image recognition failed, further information required.",
                "All existing amendment functionality has remained the same",
                "Once a decision is made (or auto-approved) email communications are sent to installer / customer - this is the only deviation from the existing amendment process. During amendments in release 1.4.0, no further communications were issued to customers / installations. This will be reversed, and communications will be sent during an amendment. These communications will be identical to the email communications issued during the 'initial application process.",
            ],
        },
    ],
    notesBodyDno: [
        {
            heading: "For DNOs using the web portal",
            subtitle: "Feature Summary",
            bullets: [
                "Amendments: The amendment functionality itself has not changed; the only update is that installers can now amend a broader range of applications. Specifically, they can amend applications that are in a qualifying state, such as Auto/DNO - approved and Further Info Required, among others",
                "More information is available in the FAQ section, providing detailed insights into the new functionality",
            ],
        },
        {
            heading: "For DNOs using our APIs",
            subtitle: "Feature Summary",
            bullets: [
                "Amendments: The amendment functionality itself has not changed; the only update is that installers can now amend a broader range of applications. Specifically, they can amend applications that are in a qualifying state, such as Auto/DNO approved or Further Info Required, among others",
                "More information is available in the FAQ section, providing detailed insights into the new functionality",
            ],
        },
    ],
    notesBodyManu: [
        {
            heading: "For manufacturers using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyDbAssessorDemand: [
        {
            heading: "For demand evaluators using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyDbAssessorGen: [
        {
            heading: "For generation evaluators using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
}
